import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "text-preview create-story-inner-text" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "img-preview"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "text-preview"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "video-preview"
}
const _hoisted_10 = ["autoplay"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["autoplay"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 3,
  class: "mosaic-item-content"
}
const _hoisted_15 = {
  key: 0,
  class: "content-wrap"
}
const _hoisted_16 = { class: "avatar" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "text"
}
const _hoisted_19 = { class: "name-story" }
const _hoisted_20 = { class: "avatar-name" }
const _hoisted_21 = {
  key: 1,
  class: "tag d-none d-lg-flex"
}

import { StoryDto } from "@/models/FilterPageTypes";
import { STORY_TYPE } from "@/models/StoryTypeEnum";
import { WINDOW_WIDTH } from "@/models/WidthTypeEnum";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StoryPreviewItem',
  props: {
    modelValue: null,
    creationLink: null,
    isVideoPlaying: { type: Boolean }
  },
  emits: ["handleStoryClick"],
  setup(__props: any, { emit }: { emit: ({
  (event: "handleStoryClick", payload: StoryDto): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: StoryDto;
  creationLink: string;
  isVideoPlaying: boolean;
};




function onStoryClick() {
  emit("handleStoryClick", props.modelValue);
}

const isDesktop = computed(() => window.innerWidth >= WINDOW_WIDTH.lg);

const isPlugStory = computed(
  () => props.modelValue.PreviewType === STORY_TYPE.Creation && props.creationLink
);
const isPreviewExists = computed(
  () =>
    (props.modelValue.DesktopPreview?.Url && isDesktop.value) ||
    (props.modelValue.MobilePreview?.Url && !isDesktop.value) ||
    props.modelValue.PreviewType == STORY_TYPE.Text
);

const isImagePreview = computed(
  () =>
    props.modelValue.PreviewType == STORY_TYPE.Image ||
    props.modelValue.PreviewType == STORY_TYPE.Audio
);
const isTextPreview = computed(() => props.modelValue.PreviewType == STORY_TYPE.Text);
const isVideoPreview = computed(() => props.modelValue.PreviewType == STORY_TYPE.Video);

const isPreviewContentExists = computed(
  () =>
    props.modelValue.AuthorLogo ||
    props.modelValue.Title ||
    props.modelValue.AuthorName ||
    props.modelValue.MainTag
);

const authorAvatarUrl = computed(() =>
  props.modelValue.AuthorLogo?.Url
    ? props.modelValue.AuthorLogo.Url
    : "/images/ico-user.svg"
);

return (_ctx: any,_cache: any) => {
  return (_unref(isPlugStory))
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: __props.creationLink,
        class: "story-creation mosaic-item mosaic-item-alt",
        style: _normalizeStyle({ backgroundColor: __props.modelValue.BackgroundColor })
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            innerHTML: __props.modelValue.Description
          }, null, 8, _hoisted_3)
        ])
      ], 12, _hoisted_1))
    : (_unref(isPreviewExists))
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: onStoryClick,
          "data-bs-toggle": "modal",
          "data-bs-target": "#storyModal-1",
          class: "mosaic-item disable-context-menu",
          style: _normalizeStyle({ backgroundColor: __props.modelValue.BackgroundColor })
        }, [
          (_unref(isImagePreview))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (__props.modelValue.DesktopPreview.Url && _unref(isDesktop))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: __props.modelValue.DesktopPreview.Url,
                      alt: ""
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (__props.modelValue.MobilePreview.Url && !_unref(isDesktop))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: __props.modelValue.MobilePreview.Url,
                      alt: ""
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]))
            : (_unref(isTextPreview))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "mosaic-text-gradient",
                    innerHTML: __props.modelValue.Description
                  }, null, 8, _hoisted_8)
                ]))
              : (_unref(isVideoPreview))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (__props.modelValue.DesktopPreview.Url && _unref(isDesktop))
                      ? (_openBlock(), _createElementBlock("video", {
                          key: 0,
                          muted: "",
                          autoplay: __props.isVideoPlaying
                        }, [
                          _createElementVNode("source", {
                            src: __props.modelValue.DesktopPreview.Url,
                            type: "video/mp4"
                          }, null, 8, _hoisted_11)
                        ], 8, _hoisted_10))
                      : _createCommentVNode("", true),
                    (__props.modelValue.MobilePreview.Url && !_unref(isDesktop))
                      ? (_openBlock(), _createElementBlock("video", {
                          key: 1,
                          muted: "",
                          autoplay: __props.isVideoPlaying
                        }, [
                          _createElementVNode("source", {
                            src: __props.modelValue.MobilePreview.Url,
                            type: "video/mp4"
                          }, null, 8, _hoisted_13)
                        ], 8, _hoisted_12))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
          (_unref(isPreviewContentExists))
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (__props.modelValue.AuthorLogo || __props.modelValue.Title || __props.modelValue.AuthorName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("img", {
                          class: "img-fluid",
                          src: _unref(authorAvatarUrl),
                          alt: ""
                        }, null, 8, _hoisted_17)
                      ]),
                      (__props.modelValue.Title || __props.modelValue.AuthorName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("p", _hoisted_19, _toDisplayString(__props.modelValue.Title), 1),
                            _createElementVNode("p", _hoisted_20, _toDisplayString(__props.modelValue.AuthorName), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (__props.modelValue.MainTag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(__props.modelValue.MainTag), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true)
}
}

})